import { useFormContext } from 'react-hook-form';
import { useEffect, useState } from 'react';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import { useBlocker } from 'react-router-dom';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';

export function UnSavedChangesDialog({ open, onLeave, onStay }) {
  return (
    <Dialog open={open}>
      <DialogTitle sx={{ padding: '8px 20px 20px', fontSize: 18 }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <InfoOutlineIcon sx={{ mr: 0.5, mt: '-1px' }} /> Unsaved changes
        </Box>
      </DialogTitle>
      <DialogContent>You have unsaved changes. Leave anyway?</DialogContent>
      <DialogActions sx={{ justifyContent: 'center' }}>
        <Button variant="contained" sie="small" onClick={onStay}>
          Stay
        </Button>
        <Button variant="outlined" sie="small" onClick={onLeave}>
          Leave
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function GlobalFormBlocker({ resetForm }) {
  const { formState } = useFormContext();
  const hasUnsavedChanges = formState.isDirty;

  const blocker = useBlocker(hasUnsavedChanges);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (blocker?.state === 'blocked') {
      setOpen(true);
    }
  }, [blocker?.state]);

  const onLeave = () => {
    resetForm();
    setOpen(false);
    blocker?.proceed();
  };

  const onStay = () => {
    setOpen(false);
    blocker?.reset();
  };

  // browser refresh / tab close (best effort)
  useEffect(() => {
    const onBeforeUnload = e => {
      if (!hasUnsavedChanges) return;
      e.preventDefault();
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', onBeforeUnload);
    return () => window.removeEventListener('beforeunload', onBeforeUnload);
  }, [hasUnsavedChanges]);

  return <UnSavedChangesDialog open={open} onLeave={onLeave} onStay={onStay} />;
}

export default GlobalFormBlocker;
